import {
    CONTACT_PAGE_RECEIVE,
    CONTACT_PAGE_ERROR,
    SET_USER_LOCATION,
    SET_SELECTED_COUNTRIES,
    SET_ALL_COUNTRIES,
    REMOVE_SELECTED_COUNTRIES,
    SET_ZOOM_LEVEL,
    SET_CENTER,
    SET_IS_CLICKED_MARKER
} from "./ContactPage.action";
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: [],
    selectedCountries: [],
    allCountries: [],
    userLocation: null,
    zoomLevel: 3.5,
    center: { lat: 48.6313, lng: 18.9999 },
    errors: [],
    isClickedMarker: false
};

export const ContactPageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case CONTACT_PAGE_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload]
            };
        case CONTACT_PAGE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            };
        case SET_USER_LOCATION:
            return {
                ...state,
                userLocation: action.payload
            };
        case SET_SELECTED_COUNTRIES:
            return {
                ...state,
                selectedCountries: action.payload
            };
        case SET_ALL_COUNTRIES:
            return {
                ...state,
                allCountries: action.payload
            };
        case REMOVE_SELECTED_COUNTRIES:
            return {
                ...state,
                selectedCountries: state.selectedCountries.filter(
                    country => country.countryName.toLowerCase() !== action.payload
                )
            };
        case SET_ZOOM_LEVEL:
            return {
                ...state,
                zoomLevel: action.payload
            };
        case SET_CENTER:
            return {
                ...state,
                center: action.payload
            };
        case SET_IS_CLICKED_MARKER:
            return {
                ...state,
                isClickedMarker: action.payload
            };
        default:
            return state;
    }
};
